import { render } from "./BaseRadio.vue?vue&type=template&id=49cea74d&scoped=true&ts=true"
import script from "./BaseRadio.vue?vue&type=script&lang=ts"
export * from "./BaseRadio.vue?vue&type=script&lang=ts"

import "./BaseRadio.vue?vue&type=style&index=0&id=49cea74d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49cea74d"]])

export default __exports__